import { Point, GlobalContext, Layer } from '../../../../context/context';
import { TransitTimeCache } from './useTransitScan';
import { generateGridPoints, getTravelTimesForGrid } from '../../processors';
import { classifyPointsByTravelTime, generateSimplePolygons } from '../../processors/transit';

interface RunTransitScanProps {
    point: Point;
    distanceKm: number;
    arrivalTime: Date;
    global: GlobalContext;
    transitTimeCache: TransitTimeCache;
    setTransitScanLoading: (loading: boolean) => void;
    setTransitScanProgress: (progress: number) => void;
    setIsTransitScanModalOpen: (open: boolean) => void;
}

export const handleRunTransitScan = async ({
    point,
    distanceKm,
    arrivalTime,
    global,
    transitTimeCache,
    setTransitScanLoading,
    setTransitScanProgress,
    setIsTransitScanModalOpen
}: RunTransitScanProps) => {
    try {
        setTransitScanLoading(true);
        setTransitScanProgress(0);

        // Generate grid points
        const gridPoints = generateGridPoints(point.coordinates, distanceKm);
        
        // Get travel times for all points
        const travelTimes = await getTravelTimesForGrid(
            gridPoints,
            point.coordinates,
            arrivalTime,
            transitTimeCache
        );

        // Classify points by travel time
        const classifiedPoints = classifyPointsByTravelTime(gridPoints, travelTimes);

        // Generate polygons for each time classification
        const timePolygons = generateSimplePolygons(classifiedPoints);

        // Create a new layer for the results
        const newLayer: Layer = {
            layerId: global.mapLayers.length + 1,
            layerName: `Transit Scan ${new Date().toLocaleTimeString()}`,
            shapes: timePolygons.map(poly => ({
                ...poly,
                id: crypto.randomUUID()
            })),
            hidden: false
        };

        // Add the new layer
        global.setLayers([...global.mapLayers, newLayer]);
        global.setActiveLayerId(newLayer.layerId);

        setIsTransitScanModalOpen(false);
    } catch (error) {
        console.error('Error running transit scan:', error);
    } finally {
        setTransitScanLoading(false);
        setTransitScanProgress(100);
    }
}; 